import { Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const FieldLabel = ({ title, isRequired = true }) => {
  const theme = useTheme();
  return (
    <Typography
      sx={{
        fontSize: 15,
        fontWeight: 600,
        mb: 1,
        ml: 1,
        mt:0.5,
        color:theme.palette.text.secondary
      }}
    >
      {title}
      {isRequired && (
        <span style={{ color: theme.palette.error.dark, marginLeft: 2 }}>
          *
        </span>
      )}
    </Typography>
  );
};

FieldLabel.propTypes = {
  title: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
};

export default FieldLabel;
